import { $api } from '@/shared/api/axiosInstance';
import { formatDateSymbols } from '@/shared/lib/utils/formatDateSymbols';

type ResponseType = {
    code: number;
    errors: null;
    exception: null;
    data: {
        url: string;
    };
};

type RequestType = {
    agreemtId: string;
    callDate: string;
    callTime: string;
    email: string;
    fio: string;
    insurancePayment: string;
    phone: string;
};

export const deposit = async ({ fio, phone, email, callDate, callTime, insurancePayment, agreemtId }: RequestType) => {
    const url = '/api/v1/replenishment';

    const { data } = await $api.post<ResponseType>(url, {
        name: fio,
        insurance_premium: insurancePayment,
        phone,
        email,
        call_date: formatDateSymbols(callDate),
        call_time: callTime,
        agreemtId,
    });

    return data;
};
